import PopupConfirmReplacement from './PopupConfirmReplacement';
export default PopupConfirmReplacement;
